import DialogContent from '@mui/material/DialogContent';
import { styled } from '@mui/material/styles';

export const DialogContentRoot = styled(DialogContent, {
  name: 'AFDialogContent',
  shouldForwardProp: prop => prop !== 'hasScroll'
})(({ theme, hasScroll }) => ({
  padding: theme.spacing(0, 3),
  marginBottom: hasScroll ? theme.spacing(3) : theme.spacing(4),
  maxHeight: '80vh',
  overflowWrap: 'break-word',
  ...(hasScroll && {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(2)
  })
}));
